var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-FirstLoadScreen"},[_c('img',{staticClass:"mb-4",staticStyle:{"margin-top":"1px"},attrs:{"src":_vm.getitLogo,"alt":"Get.It","height":"24px"}}),_c('v-progress-circular',{staticClass:"d-block",attrs:{"size":20,"color":"secondary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }